export default "__VITE_ASSET__CcShKFwz__"